<template>
  <div class="booking-page">
    <top-bar :topbarList="bookingTopBarList"></top-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import topBar from "@/components/topBar.vue";

import { bookingIndexMixins } from "@/mixins/bookingIndexMixins";

export default {
  mixins: [bookingIndexMixins],
  data() {
    return {};
  },
  computed: {},
  components: {
    topBar,
  },
};
</script>

<style lang="less" scoped>
.booking-page {
  height: 100%;
}
</style>
